import type { SVGProps } from 'react'
const LineArrowCircleUp = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M2 12C2 6.485 6.485 2 12 2s10 4.485 10 10-4.485 10-10 10S2 17.515 2 12m1.5 0c0 4.685 3.815 8.5 8.5 8.5s8.5-3.815 8.5-8.5-3.815-8.5-8.5-8.5S3.5 7.315 3.5 12m4.47-1.03 3.145-3.145a1.26 1.26 0 0 1 1.77 0l3.145 3.145-1.06 1.06-2.22-2.22v6.69h-1.5V9.81l-2.22 2.22z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineArrowCircleUp }
